import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

import { post } from "../../lib/requests";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";

import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";

import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import office2 from "assets/img/examples/office2.jpg";

const useStyles = makeStyles(sectionsPageStyle);
const useStyles2 = makeStyles(headersStyle);
const useStyles3 = makeStyles(basicsStyle);

export default function TeamT5() {
	const classes2 = useStyles2();
	const classes3 = useStyles3();

	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [billingFrequencyChecked, setBillingFrequencyChecked] = useState("");
	const [commitmentChecked, setCommitmentChecked] = useState("");

	// form validation rules
	const validationSchema = Yup.object().shape({
		PO_Number: Yup.string().required("PO Number is required"),
		Product_SKU: Yup.string().required("Product SKU is required"),
		Product_Description: Yup.string().required("Product Description is required"),
		Quantity: Yup.string().required("Quantity is required"),
		Subscription_End_Date: Yup.string(),
		Billing_Frequency: Yup.string().required("Billing Frequency is required"),
		Commitment: Yup.string().required("Commitment is required"),
		End_Customer_Name: Yup.string().required("End Customer Name is required"),
		End_Customer_Email_Address: Yup.string().required(
			"End Customer Email Address is required"
		),
		End_Customer_Contact_Number: Yup.string().required(
			"End Customer Contact Number is required"
		),
		End_Customer_Domain: Yup.string(),
		Comments_Special_Requests: Yup.string(),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		console.log("formField", formField);
		LoadingMgs("TeamT5", "processing...");
		setLoading(true);

		try {
			await post("/api/service-form/teamt5", formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("TeamT5", res.data.message);
						window.scrollTo(0, 0);
						document.body.scrollTop = 0;
						reset();
					} else {
						ErrorMessage("TeamT5", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("TeamT5", message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("TeamT5", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<div
			className={classes2.pageHeader}
			style={{
				backgroundImage: `url("${office2}")`,
			}}>
			<div className={classes2.conatinerHeader2}>
				<GridContainer>
					<GridItem
						xs={12}
						sm={10}
						md={10}
						className={classNames(
							classes2.mlAuto,
							classes2.mrAuto,
							classes2.textCenter
						)}>
						<h1 className={classes2.title}>Auscomp Cloud Service Order</h1>
						<h6 className={classes2.subTitle}>
							<span className="text-red-600 mr-2">* </span>
							Required
						</h6>
					</GridItem>
					<GridItem
						xs={12}
						sm={10}
						md={10}
						className={classNames(classes2.mlAuto, classes2.mrAuto)}>
						<Card raised className={classes2.card}>
							<CardBody formHorizontal>
								<form onSubmit={handleSubmit(onSubmit)}>
									<GridContainer>
										<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												1. PO Number <span className="text-red-600 mr-2"> * </span>
											</div>
											<CustomInput
												id="name"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("PO_Number"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.PO_Number?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												2. Product SKU <span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="product_sku"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("Product_SKU"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Product_SKU?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												3. Product Description <span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="product_description"
												inputProps={{
													placeholder: "Enter your answer here",
													autoComplete: "off",
													...register("Product_Description"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Product_Description?.message}
											</div>
										</GridItem>
										{/* Quantity */}
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												4. Quantity <span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="quantity"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("Quantity"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Quantity?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												5. Subscription End Date (If applicable)
											</div>
											<CustomInput
												id="subscription_end_date"
												inputProps={{
													placeholder: "Enter your answer here",
													type: "date",
													...register("Subscription_End_Date"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Subscription_End_Date?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle, "mb-2")}>
												6. Billing Frequency <span className="text-red-600 mr-2">* </span>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={billingFrequencyChecked === "Annual"}
															onChange={() => {
																setBillingFrequencyChecked("Annual");
																setValue("Billing_Frequency", "Annual");
															}}
															value="Annual"
															name="radio button enabled"
															aria-label="Annual"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Annual"
												/>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={billingFrequencyChecked === "Monthly"}
															onChange={() => {
																setBillingFrequencyChecked("Monthly");
																setValue("Billing_Frequency", "Monthly");
															}}
															value="Monthly"
															name="radio button enabled"
															aria-label="Monthly"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Monthly"
												/>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={billingFrequencyChecked === "Other"}
															onChange={() => {
																setBillingFrequencyChecked("Other");
																setValue("Billing_Frequency", "Other");
															}}
															value="Other"
															name="radio button enabled"
															aria-label="Other"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Other"
												/>
												{billingFrequencyChecked === "Other" && (
													<CustomInput
														id="billing_frequency"
														inputProps={{
															placeholder: "Enter your answer here",
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
												)}
												<input
													type="hidden"
													value={billingFrequencyChecked}
													{...register("Billing_Frequency")}
												/>
											</div>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Billing_Frequency?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle, "mb-2")}>
												7. Commitment <span className="text-red-600 mr-2">* </span>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={commitmentChecked === "Annual"}
															onChange={() => {
																setCommitmentChecked("Annual");
																setValue("Commitment", "Annual");
															}}
															value="Annual"
															name="radio button enabled"
															aria-label="Annual"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Annual"
												/>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={commitmentChecked === "Monthly"}
															onChange={() => {
																setCommitmentChecked("Monthly");
																setValue("Commitment", "Monthly");
															}}
															value="Monthly"
															name="radio button enabled"
															aria-label="Monthly"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Monthly"
												/>
											</div>
											<div
												className={
													classes3.checkboxAndRadio +
													" " +
													classes3.checkboxAndRadioHorizontal
												}>
												<FormControlLabel
													control={
														<Radio
															checked={commitmentChecked === "Other"}
															onChange={() => {
																setCommitmentChecked("Other");
																setValue("Commitment", "Other");
															}}
															value="Other"
															name="radio button enabled"
															aria-label="Other"
															icon={<FiberManualRecord className={classes3.radioUnchecked} />}
															checkedIcon={
																<FiberManualRecord className={classes3.radioChecked} />
															}
															classes={{
																checked: classes3.radio,
																root: classes3.radioRoot,
															}}
														/>
													}
													classes={{
														label: classes3.label,
														root: classes3.labelRoot,
													}}
													label="Other"
												/>
												{commitmentChecked === "Other" && (
													<CustomInput
														id="commitment_other"
														inputProps={{
															placeholder: "Enter your answer here",
														}}
														formControlProps={{
															fullWidth: true,
															className: classes2.formControl,
														}}
													/>
												)}
											</div>
											<input
												type="hidden"
												value={commitmentChecked}
												{...register("Commitment")}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Commitment?.message}
											</div>
										</GridItem>

										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												8. End Customer Name <span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="end_customer_name"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("End_Customer_Name"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.End_Customer_Name?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												9. End Customer Email Address{" "}
												<span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="end_customer_email_address"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("End_Customer_Email_Address"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.End_Customer_Email_Address?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												10. End Customer Contact Number{" "}
												<span className="text-red-600 mr-2">* </span>
											</div>
											<CustomInput
												id="end_customer_contact_number"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("End_Customer_Contact_Number"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.End_Customer_Contact_Number?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												11. End Customer Domain (If applicable)
											</div>
											<CustomInput
												id="end_customer_domain"
												inputProps={{
													placeholder: "Enter your answer here",
													...register("End_Customer_Domain"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.End_Customer_Domain?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={12} md={12} className={classes2.customInput}>
											<div className={classNames(classes2.labelTitle)}>
												12. Comments/Special Requests{" "}
											</div>
											<CustomInput
												id="comments_special_requests"
												inputProps={{
													placeholder: "Enter your answer here",
													type: "textarea",
													...register("Comments_Special_Requests"),
												}}
												formControlProps={{
													fullWidth: true,
													className: classes2.formControl,
												}}
											/>
											<div className="text-red-600 text-xs ml-3 pt-1">
												{errors.Comments_Special_Requests?.message}
											</div>
										</GridItem>
										<GridItem xs={12} sm={3} md={3} className={classes2.customInput}>
											<Button
												block
												color="info"
												className={classes2.button}
												type="submit"
												disabled={formState.isSubmitting}>
												Submit
											</Button>
										</GridItem>
									</GridContainer>
								</form>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		</div>
	);
}
